/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../../clients/baseClient'
import type { RequestConfig, ResponseErrorConfig } from '../../../../clients/baseClient'
import type {
  UserNotificationsUpdateApiV1NotificationsSettingsPatchMutationRequest,
  UserNotificationsUpdateApiV1NotificationsSettingsPatchMutationResponse,
  UserNotificationsUpdateApiV1NotificationsSettingsPatchHeaderParams,
  UserNotificationsUpdateApiV1NotificationsSettingsPatch422,
} from '../../types/UserNotificationsUpdateApiV1NotificationsSettingsPatch.ts'
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query'
import { useMutation } from '@tanstack/react-query'

export const userNotificationsUpdateApiV1NotificationsSettingsPatchMutationKey = () => [{ url: '/api/v1/notifications_settings' }] as const

export type UserNotificationsUpdateApiV1NotificationsSettingsPatchMutationKey = ReturnType<
  typeof userNotificationsUpdateApiV1NotificationsSettingsPatchMutationKey
>

/**
 * @summary User Notifications Update
 * {@link /api/v1/notifications_settings}
 */
export async function userNotificationsUpdateApiV1NotificationsSettingsPatch(
  data: UserNotificationsUpdateApiV1NotificationsSettingsPatchMutationRequest,
  headers?: UserNotificationsUpdateApiV1NotificationsSettingsPatchHeaderParams,
  config: Partial<RequestConfig<UserNotificationsUpdateApiV1NotificationsSettingsPatchMutationRequest>> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data
  const res = await request<
    UserNotificationsUpdateApiV1NotificationsSettingsPatchMutationResponse,
    ResponseErrorConfig<UserNotificationsUpdateApiV1NotificationsSettingsPatch422>,
    UserNotificationsUpdateApiV1NotificationsSettingsPatchMutationRequest
  >({ method: 'PATCH', url: `/api/v1/notifications_settings`, data: requestData, ...requestConfig, headers: { ...headers, ...requestConfig.headers } })
  return res.data
}

/**
 * @summary User Notifications Update
 * {@link /api/v1/notifications_settings}
 */
export function useUserNotificationsUpdateApiV1NotificationsSettingsPatch<TContext>(
  options: {
    mutation?: UseMutationOptions<
      UserNotificationsUpdateApiV1NotificationsSettingsPatchMutationResponse,
      ResponseErrorConfig<UserNotificationsUpdateApiV1NotificationsSettingsPatch422>,
      {
        data: UserNotificationsUpdateApiV1NotificationsSettingsPatchMutationRequest
        headers?: UserNotificationsUpdateApiV1NotificationsSettingsPatchHeaderParams
      },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<UserNotificationsUpdateApiV1NotificationsSettingsPatchMutationRequest>> & { client?: typeof fetch }
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? userNotificationsUpdateApiV1NotificationsSettingsPatchMutationKey()

  return useMutation<
    UserNotificationsUpdateApiV1NotificationsSettingsPatchMutationResponse,
    ResponseErrorConfig<UserNotificationsUpdateApiV1NotificationsSettingsPatch422>,
    {
      data: UserNotificationsUpdateApiV1NotificationsSettingsPatchMutationRequest
      headers?: UserNotificationsUpdateApiV1NotificationsSettingsPatchHeaderParams
    },
    TContext
  >(
    {
      mutationFn: async ({ data, headers }) => {
        return userNotificationsUpdateApiV1NotificationsSettingsPatch(data, headers, config)
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  )
}